import styled from "styled-components";

export const Sekcja = styled.section`
  scroll-margin-top: 86px;
  padding: 90px clamp(16px, 5vw, 72px);
  background: #f8faf7;

  @media (max-width: 767px) { padding-top: 64px; padding-bottom: 64px; }
`;

export const Inner = styled.div`
  max-width: 1020px;
  margin: 0 auto;
`;

export const Intro = styled.div`
  max-width: 730px;
  margin-bottom: 34px;

  > span { color: ${({ theme }) => theme.color.green}; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase; }
  h2 { margin: 10px 0 14px; font-size: clamp(34px, 5vw, 52px); line-height: 1.05; }
  p { margin: 0; color: #5f655f; font-size: 17px; line-height: 1.6; }
`;

export const Lista = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: start;

  @media (max-width: 760px) { grid-template-columns: 1fr; }
`;

export const Pytanie = styled.details`
  border: 1px solid #dfe4de;
  border-radius: 18px;
  background: #fff;
  overflow: hidden;

  summary {
    display: grid;
    grid-template-columns: 1fr 28px;
    gap: 14px;
    align-items: center;
    min-height: 82px;
    padding: 20px 22px;
    cursor: pointer;
    list-style: none;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.4;
  }

  summary::-webkit-details-marker { display: none; }
  summary span { display: grid; place-items: center; width: 28px; height: 28px; border-radius: 50%; background: #eff3ed; color: ${({ theme }) => theme.color.green}; font-size: 22px; transition: transform 180ms ease; }
  &[open] summary span { transform: rotate(45deg); background: ${({ theme }) => theme.color.orange}; color: #1d1d1b; }
  p { margin: 0; padding: 0 22px 22px; color: #5a605a; line-height: 1.65; }

  @media (max-width: 520px) {
    summary { min-height: 0; padding: 17px 18px; font-size: 15px; }
    p { padding: 0 18px 18px; font-size: 15px; }
  }
`;

export const CTA = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-top: 18px;
  padding: 24px 26px;
  border-radius: 20px;
  background: ${({ theme }) => theme.color.green};
  color: #fff;

  div { display: grid; gap: 4px; }
  span { color: rgba(255,255,255,.75); font-size: 14px; }
  a { flex: none; display: inline-flex; min-height: 46px; align-items: center; padding: 0 18px; border-radius: 999px; background: ${({ theme }) => theme.color.orange}; color: #1d1d1b; font-weight: 900; text-decoration: none; }

  @media (max-width: 640px) { align-items: flex-start; flex-direction: column; }
`;

